import { useCallback } from "react";
import useUser from "./user";
import api, { LogEventRequest } from "./api-new";
import { useAxios } from "./axios";
import amplitude from "../amplitude";

export const useLogEvent = () => {
  const [user] = useUser();
  const axios = useAxios();
  const logEvent = api.useLogEvent(axios);
  return useCallback(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (log: Pick<LogEventRequest, "type" | "details">) => {
      if (!import.meta.env.PROD) {
        console.debug("log event", log);
      }
      const details = { ...log.details, livekit_identity: user.livekitId };
      logEvent({
        type: log.type,
        details: details,
      });
      if (!amplitude) {
        return;
      }
      amplitude.logEvent(log.type, details);
    },
    [logEvent, user.livekitId]
  );
};
